// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddToCartModalController from "./add_to_cart_modal_controller"
application.register("add-to-cart-modal", AddToCartModalController)

import AsyncLoadController from "./async_load_controller"
application.register("async-load", AsyncLoadController)

import AvailabilityController from "./availability_controller"
application.register("availability", AvailabilityController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CartAvailabilityController from "./cart_availability_controller"
application.register("cart-availability", CartAvailabilityController)

import ChatSheetController from "./chat_sheet_controller"
application.register("chat-sheet", ChatSheetController)

import CartOffcanvasController from "./cart_offcanvas_controller"
application.register("cart-offcanvas", CartOffcanvasController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CheckInController from "./check_in_controller"
application.register("check-in", CheckInController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import DateRangeFilterController from "./date_range_filter_controller"
import FilterResetController from "./filter_reset_controller"
import InfiniteScrollController from "./infinite_scroll_controller"
application.register("date-range-filter", DateRangeFilterController)
application.register("filter-reset", FilterResetController)
application.register("infinite-scroll", InfiniteScrollController)

import DatetimeController from "./datetime_controller"
application.register("datetime", DatetimeController)

import DirectBookingController from "./direct_booking_controller"
application.register("direct-booking", DirectBookingController)

import DisableWithCheckboxController from "./disable_with_checkbox_controller"
application.register("disable-with-checkbox", DisableWithCheckboxController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import InlineUpdateController from "./inline_update_controller"
application.register("inline-update", InlineUpdateController)

import InteractiveCalendarController from "./interactive_calendar_controller"
application.register("interactive-calendar", InteractiveCalendarController)

import MailTemplateVariablesController from "./mail_template_variables_controller"
application.register("mail-template-variables", MailTemplateVariablesController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalShowController from "./modal_show_controller"
application.register("modal-show", ModalShowController)

import OfftimesController from "./offtimes_controller"
application.register("offtimes", OfftimesController)

import QuantityController from "./quantity_controller"
application.register("quantity", QuantityController)

import SelectizeController from "./selectize_controller"
application.register("selectize", SelectizeController)

import SiteEditModalController from "./site_edit_modal_controller"
application.register("site-edit-modal", SiteEditModalController)

import SubmitFormController from "./submit_form_controller"
application.register("submit-form", SubmitFormController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TomSelectThumbnailsController from "./tom_select_thumbnails_controller"
application.register("tom-select-thumbnails", TomSelectThumbnailsController)

import TomselectController from "./tomselect_controller"
application.register("tomselect", TomselectController)

import TooltipsController from "./tooltips_controller"
application.register("tooltips", TooltipsController)

import UserEditModalController from "./user_edit_modal_controller"
application.register("user-edit-modal", UserEditModalController)

import UserInfoController from "./user_info_controller"
application.register("user-info", UserInfoController)

import BridgeAvatarController from "./bridge/avatar_controller"
application.register("bridge--avatar", BridgeAvatarController)

import BridgePageController from "./bridge/page_controller"
application.register("bridge--page", BridgePageController)

import BridgeButtonController from "./bridge/button_controller"
application.register("bridge--button", BridgeButtonController)

import BridgeMenuController from "./bridge/menu_controller"
application.register("bridge--menu", BridgeMenuController)

import BridgeTabBadgeController from "./bridge/tab_badge_controller"
application.register("bridge--tab-badge", BridgeTabBadgeController)
